
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-events/news",
      function () {
        return require("private-next-pages/news-and-events/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-events/news"])
      });
    }
  